import { FlisRecordResult } from '@/api/api';
import { useDebouncedValue } from '@/hooks/useDebouncedValue';
import { api } from '@/services/api';
import { useTenants } from '@/services/tenants/useTenants';
import { AxiosApiError } from '@/types/apiError';
import { useQuery } from '@tanstack/react-query';

export const FLIS_RECORD_SEARCH_QUERY_KEY = 'flisRecordSearch';

const MIN_SEARCH_LENGTH = 1;
const SUGGESTION_LIMIT = 20;
const DEBOUNCE_MS = 300;

export const useSearchFlisRecords = (searchTerm: string) => {
  const { getTenantId } = useTenants();
  const tenantId = getTenantId();

  const debouncedTerm = useDebouncedValue(searchTerm.trim(), DEBOUNCE_MS);
  const enabled = !!tenantId && debouncedTerm.length >= MIN_SEARCH_LENGTH;

  const { data, isFetching } = useQuery<FlisRecordResult[], AxiosApiError>({
    queryKey: [FLIS_RECORD_SEARCH_QUERY_KEY, tenantId, debouncedTerm],
    queryFn: async () => {
      const response = await api.tenants.searchFlisRecords(tenantId, debouncedTerm, SUGGESTION_LIMIT);
      return response.data.flisRecords;
    },
    enabled,
  });

  return { flisRecords: enabled ? (data ?? []) : [], isFetching };
};
